<template>
    <ol-vector-layer :zIndex="5" :name="layer.id" :title="layer.id" 
        :properties="layerProperties"
        updateWhileInteracting 
        ref="ComponentRef">
        <ol-source-vector v-if="layer?.id" :features="features" :projection="layer?.projection" >
            <ol-style :overrideStyleFunction="overrideStyleFunction">
                <ol-style-stroke color="#063" :width="3"></ol-style-stroke>
                <ol-style-fill color="rgba(255,255,255,0)"></ol-style-fill>
                <ol-style-text text="..."></ol-style-text>
            </ol-style>
        </ol-source-vector>
    </ol-vector-layer>
</template>



<script setup>
import { ref, computed, onMounted, inject } from 'vue'
import { q250_geojson } from '@/components/map/utils/UTMPNGP250'



import { Fill } from 'ol/style.js';

import GeoJSON from 'ol/format/GeoJSON.js'

const layer = defineModel("layer")
const props = defineProps(["currentCenter", "viewProjection"])

// const {asd, currentCenter} = toRefs(props)


const layerProperties = () => {
    // console.log(layer.value.properties)
    return layer.value?.properties || {}
}


// const getProperties = () =>
//  {  console.log(layer.value.properties)
//     return layer.value.properties
// }

// getProperties()


// const ComponentRef = ref(null)

// const center = ref([359524, 5051973])

// // setInterval(() => {
// //     center.value = [].concat(props.currentCenter.epsg32632)
// //     console.log(props.currentCenter.epsg32632)
// // }, 1000)


const features = computed(() => {
        return new GeoJSON().readFeatures(q250_geojson(props.currentCenter.epsg32632.value), {
            dataProjection: "EPSG:32632",
            featureProjection: "EPSG:3857",
        })
});




onMounted(() => {
    console.log("q250 mounted")
    console.log(features)

})


const overrideStyleFunction = (feature, style) => {

    let title = feature.get('title');  //from extra data in properties of the feature
    // console.log(title)

    style.getText().setFont('20px sans-serif');
    style.getText().setTextAlign('center');
    style.getText().setTextBaseline('middle');
    style.getText().setPadding([1, 2, 1, 5]);
    // set background

    style.getText().setBackgroundFill(new Fill({
        color: 'rgba(255,255,255,0.5)'
    }));



    style.getText().setText(title);
    // center the text in the feature
    style.getText().setRotation(.01);


    // console.log(style)
    return style


};


// styles https://openlayers.org/en/latest/examples/vector-labels.html

</script>
